// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, buscas, catálogo e os carregadores.
export {
  collectionAgreementScreen,
  collectionAgreementsScreen,
  collectionDashboardScreen,
  collectionDebtorScreen,
  collectionQueueScreen,
} from './collection.screen';
export { agreementSearch, agreementsSearch, dashboardSearch, debtorSearch, queueSearch } from './collection.search';
export { loadCollectionMessages } from './collection.catalog';

/** As telas das rotas, por `lazyScreen`. */
export const loadCollectionScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadCollectionGuides = () => import('./collection.guide');
